import React from 'react';

const PaymentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.5 6.66667C2.5 5.74619 3.24619 5 4.16667 5H15.8333C16.7538 5 17.5 5.74619 17.5 6.66667V13.3333C17.5 14.2538 16.7538 15 15.8333 15H4.16667C3.24619 15 2.5 14.2538 2.5 13.3333V6.66667Z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M2.5 8.33333H17.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M6.66667 12.5H8.33333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M11.6667 12.5H13.3333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export default PaymentIcon;

